import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { ExperienceAdapter, ExperienceOverview, trackElement } from '@shared';

@Component({
  selector: 'mojo-candidate-resume-card',
  templateUrl: './candidate-resume-card.component.html',
  styleUrls: ['./candidate-resume-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateResumeCardComponent implements OnChanges {
  private readonly charactersLimit = 2000;

  @Input() overview: ExperienceOverview;
  @Input() experiences: ExperienceAdapter[];
  @Input() showCard = true;
  trackElement = trackElement;
  expanded = false;
  expandable = false;

  displayedOverview: ExperienceOverview;
  displayedExperiences: ExperienceAdapter[];

  ngOnChanges() {
    this.prepareDisplayData();
  }

  toggleCard(expanded: boolean) {
    this.expanded = expanded;
    this.prepareDisplayData();
  }

  prepareDisplayData() {
    if (this.expanded) {
      this.displayedOverview = this.overview;
      this.displayedExperiences = this.experiences;
    } else {
      this.displayedExperiences = [];
      this.expandable = false;

      this.prepareDisplayedOverview();
      this.prepareExperiencesToDisplay();
    }
  }

  private prepareDisplayedOverview() {
    if (!this.overview) {
      return;
    }
    this.displayedOverview = { ...this.overview };
    if (this.overview.text.length > this.charactersLimit) {
      this.displayedOverview.text = this.overview.text.substring(0, this.charactersLimit);
      this.expandable = true;
    }
  }

  private prepareExperiencesToDisplay() {
    let currentCharactersNumber = this.overview?.text?.length;
    if (!this.experiences) {
      return;
    }
    this.experiences.forEach(({ source }) => {
      if (!source.jobSummary || currentCharactersNumber >= this.charactersLimit) {
        return;
      }

      const experienceSource = { ...source };
      if (experienceSource.jobSummary.length >= this.charactersLimit - currentCharactersNumber) {
        experienceSource.jobSummary = experienceSource.jobSummary.substring(
          0,
          this.charactersLimit - currentCharactersNumber,
        );
        this.expandable = true;
      }
      currentCharactersNumber += experienceSource.jobSummary.length;
      this.displayedExperiences.push(new ExperienceAdapter(experienceSource));
    });
  }
}
